<template>
  <!-- 收藏统计 -->
  <div class="goodsInterface">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['接口查询',$route.meta.title]">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData">导出数据</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入关键字" v-model="searchForm.name"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="ERP编号">
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="商品名称">
      </el-table-column>
      <el-table-column
        prop="spec"
        align="center"
        show-overflow-tooltip
        label="商品规格">
      </el-table-column>
      <el-table-column
        prop="unit"
        align="center"
        show-overflow-tooltip
        label="包装单位">
      </el-table-column>
      <el-table-column
        prop="factory"
        align="center"
        show-overflow-tooltip
        label="生产厂家">
      </el-table-column>
      <el-table-column
        prop="type"
        align="center"
        show-overflow-tooltip
        label="商品分类">
      </el-table-column>
      <el-table-column
        prop="specSp"
        align="center"
        show-overflow-tooltip
        label="计量规格">
      </el-table-column>
      <el-table-column
        prop="stock"
        align="center"
        show-overflow-tooltip
        label="库存">
      </el-table-column>
      <el-table-column
        prop="newValdate"
        align="center"
        show-overflow-tooltip
        label="新效期">
      </el-table-column>
      <el-table-column
        prop="oldValdate"
        align="center"
        show-overflow-tooltip
        label="老效期">
      </el-table-column>
      <el-table-column
        prop="entId"
        align="center"
        show-overflow-tooltip
        label="机构">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
  </div>
</template>

<script>

export default {
  name: 'goodsInterface',
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        name: ''
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    }
  },
  mounted() {
    this.getTableData()
  },
  methods:{
    /**获取表格数据 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      let data = {
        type: "Int_goods_info",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      }
      let proc = "Proc_Admin_GoodsList" // 存储过程名
      let type = "ReturnList"
      this.$requestSys({
        method: 'post',
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then(res => {
        this.tableData = []
        this.allPage = 0
        if(res.flag == 0){
          this.allPage = res.recordCount
          this.tableData = res.data.map(item => ({
            id: item.spbh, // ERP编号
            name: item.spmch, // 商品名称
            spec: item.shpgg, // 商品规格
            unit: item.dw, // 包装单位
            factory: item.shengccj, // 生产厂家
            type: item.leibie, // 商品分类
            specSp: item.jlgg, // 计量规格
            stock: item.kcshl, // 库存
            newValdate: item.xq_new, // 新效期
            oldValdate: item.xq_old, // 老效期
            entId: item.entid, // 机构
          }))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**刷新数据 */
    handleRefresh(){
      this.getTableData()
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val
      this.getTableData()
    },
    exportData(){
      let data = {
        type: "Int_goods_info",
        strWhere: this.searchForm.name,
        userId: window.localStorage.getItem('userId'),
        entId: window.localStorage.getItem('entId'),
        PageIndex: 1,
        PageSize: 9999999,
      }
      let proc = "Proc_Admin_GoodsList" // 存储过程名
      window.location.href = this.baseUrl + "Order/NoPIGExprot?json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + encodeURIComponent(proc) + "&name=商品接口"
    },
  }
}
</script>

<style scoped>
.goodsInterface{
  width: 100%;
  height: 100%;
}
</style>
